import { RegionCode } from "types";
const DEV_STRIPE_KEYS = "pk_test_9apl7R6j03VV0g4afCk4Wko900ktLCOSaq";
const PROD_STRIPE_KEYS = "pk_live_9Yz7JNlZt2VbmZOI0ClCN2cs00IV3lvIiq";

const DEV_GOOGLE_RECAPTCHA = "6Lew85csAAAAAJkxInXPVZBDallZ1vKqjsjEQRRe";
const PROD_GOOGLE_RECAPTCHA = "6LcyEZgsAAAAAMPDjaItDP55BvBg_TjzAahb0Oto";
export const LIVE_TEST_SIGNUP_PROD_GOOGLE_RECAPTCHA =
  "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

// For Google SSO button
const DEV_GOOGLE_CLIENT_ID =
  "204228388555-g84uhi56ru29b9ni727rjckc5fck8h8g.apps.googleusercontent.com";
const PROD_GOOGLE_CLIENT_ID =
  "204228388555-14k5on76k1l13lcnc9pin24elbm9j65q.apps.googleusercontent.com";

const DEV_WEB_ENDPOINT = "https://dev-responses.timescale.com"; // `web-endpoint` is a proxy for a lot of requests
const PROD_WEB_ENDPOINT = "https://responses.timescale.com";

const DEV_HUBSPOT = `${DEV_WEB_ENDPOINT}/v2/`;
const PROD_HUBSPOT = `${PROD_WEB_ENDPOINT}/v2/`; //If this is changed, the CSP needs to be changed to match at server/csp_template.yml

// Slack webhook endpoints
const DEV_SLACK_WEBHOOKS = `${DEV_WEB_ENDPOINT}/v1/slack/`;
const PROD_SLACK_WEBHOOKS = `${PROD_WEB_ENDPOINT}/v1/slack/`;

const DEV_HUBSPOT_FORM_ID = "bf7be759-c474-403b-8769-945d0cd11020";
const PROD_HUBSPOT_FORM_ID = "e9f0edd7-cc50-42ac-b971-22e14f7c406e";

export const ALGOLIA_ID = "FZW5UHSSH8";
export const ALGOLIA_READ_KEY = "208c061facd1acf573b1bb575eca48ce";
const DEV_ALGOLIA_INDEX = "docs_console_dev";
const PROD_ALGOLIA_INDEX = "docs_console_prod";

// Tiger bounces to our FusionAuth server to package a token and then redirects back to PopSQL.
// You'll need to append `projectId` to the end of the redirect URL to ensure the correct project is loaded.
const POPSQL_CLIENTID_DEV = "65183398-ece9-40c4-84e7-84974c51255b";
const POPSQL_CLIENTID_PROD = "df218f30-0913-49d3-b78c-15ccb31641a6";
const POPSQL_APP_ORIGIN_LOCAL = "https://app.local.popsql.team";
const POPSQL_APP_ORIGIN_DEV = "https://app.popsql.dev";
const POPSQL_APP_ORIGIN_PROD = "https://app.popsql.com";
const POPSQL_REDIRECT_LOCAL =
  "https://local.popsql.team/users/auth/timescale_console/callback";
const POPSQL_REDIRECT_DEV =
  "https://popsql.dev/users/auth/timescale_console/callback";
const POPSQL_REDIRECT_PROD =
  "https://popsql.com/users/auth/timescale_console/callback";

// const TIMESCALE_AUTH_FOR_POPSQL_LOCAL = `https://console.dev.timescale.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_DEV}&response_type=code&redirect_uri=${POPSQL_REDIRECT_LOCAL}&project=`;
export const TIMESCALE_AUTH_FOR_POPSQL_DEV = `https://console.dev.timescale.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_DEV}&response_type=code&redirect_uri=${POPSQL_REDIRECT_DEV}&project=`;
export const TIMESCALE_AUTH_FOR_POPSQL_PROD = `https://console.cloud.timescale.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_PROD}&response_type=code&redirect_uri=${POPSQL_REDIRECT_PROD}&project=`;

const TIGERDATA_AUTH_FOR_POPSQL_LOCAL = `https://console.dev.tigerdata.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_DEV}&response_type=code&redirect_uri=${POPSQL_REDIRECT_LOCAL}&project=`;
const TIGERDATA_AUTH_FOR_POPSQL_DEV = `https://console.dev.tigerdata.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_DEV}&response_type=code&redirect_uri=${POPSQL_REDIRECT_DEV}&project=`;
const TIGERDATA_AUTH_FOR_POPSQL_PROD = `https://console.cloud.tigerdata.com/api/idp/external/popsql/login?client_id=${POPSQL_CLIENTID_PROD}&response_type=code&redirect_uri=${POPSQL_REDIRECT_PROD}&project=`;

const CHAT_URL_LOCAL = `${import.meta.env.VITE_CHAT_URL || "https://chat.popsql.dev"}/api`;
const CHAT_URL_DEV = "https://chat.popsql.dev/api";
const CHAT_URL_PROD = "https://chat.popsql.dev/api";

export const POPSQL_WINDOW_TARGET = "popsql_window";

export const MAINTENANCE_WINDOW_DURATION = 2; //hours

export const USERPILOT_ACCOUNT_ID = "NX-271ca217";

//Note: These must be kept in sync with external env variable names
export const PROD = "production";
export const DEV = "development";

export const denyUrls = [
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  /chrome-extension/,
  // Google reCAPTCHA's minified bundle; its internal errors are not app code.
  // Our own assets live under /assets/, so this cannot match them.
  /\/recaptcha\/(api|releases)\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
];

const SENTRY_CONFIG =
  "https://6c2c1c92b24f43c8a4adeaf8ce852856@o417395.ingest.sentry.io/5317137";

// Why "hogpost"?
// https://posthog.com/docs/advanced/proxy
// "It is best practice to use a subdomain that does not include posthog, analytics, tracking, or other similar words."
const POSTHOG_CONFIG = {
  PUBLIC_KEY: "phc_OsZpGzq2LBW8OMXjdktxavhYkehe8R05zsW0zN6prLF",
  PUBLIC_HOST: "https://hogpost.sre.tigerdata.com",
};

// StatSig original url is "https://api.statsig.com/v1" and this is our proxy.
export const STAT_SIG_API_URL =
  import.meta.env.VITE_STATSIG_API_URL ||
  "https://statsig.sre.tigerdata.com/v1";
export const STAT_SIG_CLIENT_KEY =
  "client-JWxl64CuAw9dnpymDndqVdkerj3l92J6LE2E5fFVTaH";

export const PROD_AWS_ACCOUNT_ID = "142548018081";
export const DEV_AWS_ACCOUNT_ID = "442426855243";

export const PROD_PROMETHEUS_DOMAIN = "tsdb.cloud.timescale.com";
const DEV_PROMETHEUS_DOMAIN = "dev.timescale.com";

export const STATSIG_SEGMENT_ADD_USER_ENDPOINT = "v1/statsig/segment/add-user";

export const ENVS = {
  production: {
    NAME: PROD,
    GOOGLE_RECAPTCHA: PROD_GOOGLE_RECAPTCHA,
    GOOGLE_CLIENT_ID: PROD_GOOGLE_CLIENT_ID,
    SLACK_WEBHOOKS_ENDPOINTS: PROD_SLACK_WEBHOOKS,
    WEB_ENDPOINT: PROD_WEB_ENDPOINT,
    HUBSPOT: PROD_HUBSPOT,
    HUBSPOT_FORM_ID: PROD_HUBSPOT_FORM_ID,
    STRIPE_KEY: PROD_STRIPE_KEYS,
    SENTRY: SENTRY_CONFIG,
    ALGOLIA_INDEX: PROD_ALGOLIA_INDEX,
    POPSQL_APP_ORIGIN: POPSQL_APP_ORIGIN_PROD,
    POPSQL_REDIRECT: TIGERDATA_AUTH_FOR_POPSQL_PROD,
    FALLBACK_REGION: RegionCode.US_EAST_2,
    CHAT_URL: CHAT_URL_PROD,
    POSTHOG_CONFIG,
    PROMETHEUS_DOMAIN: PROD_PROMETHEUS_DOMAIN,
    PROMETHEUS_AZURE_DOMAIN: "db.az.tigerdata.com",
  },
  development: {
    NAME: DEV,
    GOOGLE_RECAPTCHA: DEV_GOOGLE_RECAPTCHA,
    GOOGLE_CLIENT_ID: DEV_GOOGLE_CLIENT_ID,
    SLACK_WEBHOOKS_ENDPOINTS: DEV_SLACK_WEBHOOKS,
    WEB_ENDPOINT: DEV_WEB_ENDPOINT,
    HUBSPOT: DEV_HUBSPOT,
    HUBSPOT_FORM_ID: DEV_HUBSPOT_FORM_ID,
    STRIPE_KEY: DEV_STRIPE_KEYS,
    SENTRY: SENTRY_CONFIG,
    ALGOLIA_INDEX: DEV_ALGOLIA_INDEX,
    POPSQL_APP_ORIGIN: POPSQL_APP_ORIGIN_DEV,
    POPSQL_REDIRECT: TIGERDATA_AUTH_FOR_POPSQL_DEV,
    FALLBACK_REGION: RegionCode.US_EAST_1,
    CHAT_URL: CHAT_URL_DEV,
    POSTHOG_CONFIG,
    PROMETHEUS_DOMAIN: DEV_PROMETHEUS_DOMAIN,
    PROMETHEUS_AZURE_DOMAIN: "db.az-dev.tigerdata.com",
  },
  local: {
    NAME: DEV,
    GOOGLE_RECAPTCHA: DEV_GOOGLE_RECAPTCHA,
    GOOGLE_CLIENT_ID: DEV_GOOGLE_CLIENT_ID,
    SLACK_WEBHOOKS_ENDPOINTS: DEV_SLACK_WEBHOOKS,
    WEB_ENDPOINT: DEV_WEB_ENDPOINT,
    HUBSPOT: DEV_HUBSPOT,
    HUBSPOT_FORM_ID: DEV_HUBSPOT_FORM_ID,
    STRIPE_KEY: DEV_STRIPE_KEYS,
    SENTRY: SENTRY_CONFIG,
    ALGOLIA_INDEX: DEV_ALGOLIA_INDEX,
    POPSQL_APP_ORIGIN: !import.meta.env.VITE_LOCAL_POPSQL
      ? POPSQL_APP_ORIGIN_LOCAL
      : POPSQL_APP_ORIGIN_DEV,
    POPSQL_REDIRECT: !import.meta.env.VITE_LOCAL_POPSQL
      ? TIGERDATA_AUTH_FOR_POPSQL_LOCAL
      : TIGERDATA_AUTH_FOR_POPSQL_DEV,
    FALLBACK_REGION: RegionCode.US_EAST_1,
    CHAT_URL: CHAT_URL_LOCAL,
    POSTHOG_CONFIG,
    PROMETHEUS_DOMAIN: DEV_PROMETHEUS_DOMAIN,
    PROMETHEUS_AZURE_DOMAIN: "db.az-dev.tigerdata.com",
  },
};

export const prHostRegex = /^savannah-tiger-cloud-pr-\d+\.onrender\.com$/;

export const API_ENV = (() => {
  const host = import.meta.env.VITE_API_HOSTNAME;
  switch (host) {
    case "https://console.cloud.timescale.com":
    case "https://console.cloud.tigerdata.com":
      return ENVS["production"];
    case "https://console.dev.timescale.com":
    case "https://console.dev.tigerdata.com":
      return ENVS["development"];
    default:
      // PR instances should use development config
      // e.g. https://savannah-tiger-cloud-pr-4480.onrender.com
      if (host && prHostRegex.test(host)) return ENVS["development"];
      return ENVS["local"];
  }
})();

export const IDP_REQUIRED_EMAIL =
  /identity provider must be used for this email domain/i;

export const CONNECTION = {
  ONLINE: "online",
  OFFLINE: "offline",
} as const;

export const PAGE = {
  IDLE: "idle",
  ACTIVE: "active",
} as const;

export const STATUS = {
  //these values mirror graphQL enum Service.status
  QUEUED: "QUEUED",
  DELETING: "DELETING",
  CONFIGURING: "CONFIGURING",
  READY: "READY",
  DELETED: "DELETED",
  UNSTABLE: "UNSTABLE",
  PAUSING: "PAUSING",
  RESUMING: "RESUMING",
  PAUSED: "PAUSED",
  READ_ONLY: "READ_ONLY",
  UPGRADING: "UPGRADING",
  OPTIMIZING: "OPTIMIZING",
} as const;

export const ACTION = {
  ACCEPT: "ACCEPT",
  DECLINE: "DECLINE",
} as const;

export const IN_PROGRESS_STATUSES = [
  STATUS.QUEUED,
  STATUS.PAUSING,
  STATUS.RESUMING,
  STATUS.UPGRADING,
];

export const NOTES = {
  DEMO: "demo",
  SERVICE: "service",
  VPC: "vpc",
  FORK: "fork",
};

export const RESOURCE_EVENT_TYPES = {
  IN_PROGRESS: "in_progress",
  CPU_COMPLETE: "cpu_complete",
  STORAGE_COMPLETE: "storage_complete",
  CPU_AND_STORAGE_COMPLETE: "cpu_and_storage_complete",
};

export const FORM_SUBSCRIPTION_IDS = {
  newsletter: 7930475,
  forge: 9175664,
};

export const INVOICE_STATUS = {
  PAID: "paid",
  SENT: "sent",
};

export const TS_DEFAULT_USER = "tsdbadmin";
export const TS_DEFAULT_DB = "tsdb";
export const TS_BLANK_PASSWORD = "<TIMESCALE_DB_PASSWORD>";

/** When doing alphabetical sorting, we might want to sort "-" (aka nothing to show)
 *  before values that start with an underscore "_". The ASCII table comes sorted like:
 *
 *    !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`abcdefghijklmnopqrstuvwxyz{|}~
 *
 *  We can add a space before the "-" to make it sort before "_", without resorting
 *  to a custom sorting function.
 */
export const SORTED_DASH = " -";
